<template>
    <nav
        class="IndustryTopbar bg--blue-charcoal"
    >
        <div class="container flex-center-b">
            <HeaderLogo
                classes="header-topbar"
            />

            <a
                href="/"
                class="IndustryTopbar__content block flex-center-end"
            >

                <span>{{ text }}</span>
                <strong class="px-min">Click here</strong>
                <BaseIcon
                    icon="arrow-right2"
                />
            </a>
        </div>
    </nav>
</template>
<script>
export default {
    name: 'IndustryTopbar',
    props: {
        text: {
            type: String,
            default: null,
        }
    }
}
</script>
<style lang="scss" scoped>
    .IndustryTopbar {
        padding: 0.65rem 0;
        color: getColor('white');
        font-size: 12px;
        position: relative;
        z-index: 10;

        @include media-query(lap-and-up) {
            font-size: 14px;
        }
    }

    .IndustryTopbar__content {
        line-height: 1.2;

        @include media-query(palm) {
            width: 100%;
            text-align: right;
        }

        svg {
            position: relative;
            top: 2px;
        }
    }

    .HeaderLogo {

        svg {
            height: 14px;
            width: auto;
            fill: getColor('white');
        }

        @include media-query(palm) {
            display: none;
        }
    }
</style>
